<template>
	<div class="rowForm" v-if="!isEditSideScreens">
		<div class="rowForm-title">Параметры ряда</div>
		<!--
		<div class="rowForm-field">
			<label>Нагрузка на ярус, кг</label>
			<Select v-model="capacity" :options="options.capacity"></Select>
		</div>
		-->
		<div class="rowForm-field">
			<label>Высота стеллажа, мм</label>
			<Select v-model="height" :options="options.height"></Select>
		</div>
		<div class="rowForm-field">
			<label>Глубина стеллажа, мм</label>
			<Select v-model="depth" :options="options.depth"></Select>
		</div>
		<!-- <div class="rowForm-field">
			<label>Длина, мм</label>
			<Select v-model="width" :options="options.width"></Select>
		</div>
		<div class="rowForm-field">
			<label>Кол-во ярусов</label>
			<Select v-model="count" :options="options.count"></Select>
		</div> -->
		<div class="rowForm-title">Стойки
			<Info>
				выбор общей стойки уменьшает максимальную нагрузку на полку и стеллаж
			</Info>
		</div>
		<div class="rowForm-field">
			<Radio v-model="separate" :value="true" :checkedValue="separate ? false : true">
				Отдельные стойки
			</Radio>
			<br>
			<Radio v-model="separate" :value="false" :checkedValue="separate ? false : true">
				Общие стойки
			</Radio>
		</div>
		<button @click="$emit('submit', $data)">{{ isNew ? 'Создать' : 'Применить'}}</button>
	</div>
	<div class="rowForm" v-else>
		<div class="rowForm-title">Боковые экраны ряда
			<Info>Внешние стенки крайних 
				стеллажей ряда
			</Info>
		</div>

		<div class="rowForm-field">
			<Radio v-model="accessories.side_screen" :value="false" :checkedValue="accessories.side_screen ? false : true">
				Нет
			</Radio>
			<br>
			<Radio v-model="accessories.side_screen" :value="true" :checkedValue="accessories.side_screen ? false : true">
				Боковые экраны
			</Radio>
			<div class="count-wrap" v-if="accessories.side_screen">
				Кол-во:<input type="number" :value="display_side_screen_count" @input="changeCount" /> комп.
			</div>
		</div>
		<button @click="$emit('submit', $data)">{{ isNew ? 'Создать' : 'Применить'}}</button>
	</div>
</template>

<script>
	import Info from './Info';
	import Radio from './Radio';
	import Select from './Select';

	export default {
		name: 'RowForm',
		inject: {
			options: 'options',
		},
		props: {
			data: Object,
			isNew: Boolean,
			isEditSideScreens: Boolean,
		},
		data() {
			return {
				separate: true,
				capacity: 0,
				height: 0,
				depth: 0,
				width: 0,
				count: 0,
				...this.data,
			};
		},
		computed: {
			display_side_screen_count() {
				return this.accessories.side_screen_count ? this.accessories.side_screen_count : 1;
			}
		},
		components: {
			Select,
			Info,
			Radio,
		},
		methods: {
			changeCount(event) {
				this.accessories.side_screen_count = event.target.value
			}
		},
	}
</script>

<style scoped>
	.rowForm {
		padding: 32px;
		width: 264px;
		font-size: 14px;
		background: #F6F6F6;
	}
	.rowForm-title {
		font-family: Oswald, Roboto, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
		letter-spacing: 0.03em;
		text-transform: uppercase;
		color: #A7A7A7;
	}
	.rowForm-field {
		margin: 22px 0 30px;
	}
	select {
		margin-top: 10px;
		width: 100%;
	}
	.count-wrap {
		margin: -10px 0 0 33px;
	}
	.count-wrap input {
		margin: 0 9px;
		width: 47px;
		height: 32px;
		text-align: center;
		background: white;
		border: 1px solid #CECECE;
		appearance: textfield;
	}
</style>
